import { render } from "./IndexSolutionCaption.vue?vue&type=template&id=12534fad&scoped=true"
import script from "./IndexSolutionCaption.vue?vue&type=script&lang=js"
export * from "./IndexSolutionCaption.vue?vue&type=script&lang=js"

import "./IndexSolutionCaption.vue?vue&type=style&index=0&id=12534fad&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anderson\\Documents\\GitHub\\px40-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12534fad"]])

export default __exports__